import { createRef, render } from "preact";

import type { WidgetConfig } from "./types";
import { App } from "./App";

import "./styles/index.css";

// Initialize all widget instances on the page
function initWidgets() {
  const containers = document.querySelectorAll<HTMLElement>(".festapp-widget");

  containers.forEach((container) => {
    const configAttr = container.getAttribute("data-config");
    if (!configAttr) {
      console.error("FEST App Widget: Missing data-config attribute");
      return;
    }

    try {
      const config: WidgetConfig = JSON.parse(configAttr);

      if (!config.editionId) {
        console.error("FEST App Widget: Missing required config (editionId)");
        container.innerHTML = '<div class="festapp-error"><p>Widget configuration error: missing edition ID</p></div>';
        return;
      }

      const containerRef = createRef<HTMLElement>();
      containerRef.current = container;

      render(<App config={config} containerRef={containerRef} />, container);
    } catch (e) {
      console.error("FEST App Widget: Failed to parse config", e);
      container.innerHTML = '<div class="festapp-error"><p>Widget configuration error</p></div>';
    }
  });
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWidgets);
} else {
  initWidgets();
}
